import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateUpdateSpecialtyValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string().required('Name is required'),
    path: Yup.string().required('Path is required')
  });

export default function useSpecialtyFormik(specialtyData = {}, onSubmit) {
  const formik = useFormik({
    initialValues: {
      id: specialtyData?.id ?? null,
      name: specialtyData?.name ?? '',
      path: specialtyData?.path ?? ''
    },
    enableReinitialize: true,
    validationSchema: CreateUpdateSpecialtyValidationSchema,
    onSubmit
  });

  return formik;
}
